import { SET_SUCCESS } from "./types";

export const set_success = (data) => ({
    type: SET_SUCCESS,
    data: data
});

export const set_success_func = (data) => (dispatch) => {
    dispatch(set_success(data));
}